// extracted by mini-css-extract-plugin
module.exports = {"name":"Regist_name__1qtNC","user_data":"Regist_user_data__3OL0A"};